export default __webpack_public_path__ + "static/media/africa-countries.e692ea13.geojson";